/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable camelcase */
import React, { useState, useEffect, useMemo } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import MaterialReactTable from 'material-react-table';
import { ptBR } from '@mui/material/locale';
import { get } from 'lodash';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import {
  createTheme,
  ThemeProvider,
  useTheme,
  Grid,
  Box,
  Button,
  Autocomplete,
  TextField,
  Card,
  CardContent,
  Divider,
  Typography,
  Tooltip,
  Modal,
} from '@mui/material';
import { FaPrint } from 'react-icons/fa';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import moment from 'moment';
import * as actions from '../../store/modules/auth/actions';
import NumberFormatCustom from '../../utils/NumberFormatCustom';
import NumberFormat from '../../utils/NumberFormat';
import { ContainerPainel, Title, SubTitle } from '../../styles/GlobalStyles';
import Loading from '../../components/Loading';
import axios from '../../services/axios';
import * as colors from '../../config/colors';
import RelatorioViagens from '../RelatorioViagem';

// Estilo para o modal
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '76.5%',
  height: '95%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  overflow: 'auto',
};

dayjs.locale('pt-br');

export default function Dashboard() {
  const dispatch = useDispatch();
  const [motoristas, setMotoristas] = useState([]);
  const [veiculos, setVeiculos] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [totalizadores, setTotalizadores] = useState({});
  const [viagens, setViagens] = useState([]);

  const [id_motorista, setIdMotorista] = useState(null);
  const [id_veiculo, setIdVeiculo] = useState(null);
  const [id_empresa, setIdEmpresa] = useState(null);
  const [id_cliente, setIdCliente] = useState(null);
  const [dtinicial, setDtInicial] = useState(null);
  const [dtfinal, setDtFinal] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const handleOpen = (id) => {
    setSelectedId(id);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setSelectedId('');
  };
  const theme = useTheme();

  // Busca a lista de motoristas
  useEffect(() => {
    setIsLoading(true);
    async function fetchMotoristas() {
      const response = await axios.get('/motoristas');
      setMotoristas(response.data);
    }
    async function fetchVeiculos() {
      const response = await axios.get('/veiculos');
      setVeiculos(response.data);
    }
    async function fetchEmpresas() {
      const response = await axios.get('/empresas');
      setEmpresas(response.data);
    }
    async function fetchClientes() {
      const response = await axios.get('/clientes');
      setClientes(response.data);
    }
    fetchMotoristas();
    fetchVeiculos();
    fetchEmpresas();
    fetchClientes();
    setIsLoading(false);
  }, []);

  // Busca a lista de viagens de acordo com o motorista selecionado
  async function fetchAll() {
    const params = {};
    try {
      setIsLoading(true);
      if (id_empresa) {
        params.id_empresa = id_empresa;
      }
      if (id_motorista) {
        params.id_motorista = id_motorista;
      }
      if (id_veiculo) {
        params.id_veiculo = id_veiculo;
      }
      if (id_cliente) {
        params.id_cliente = id_cliente;
      }
      if (dtinicial) {
        params.dtinicial = dtinicial || null;
      }
      if (dtfinal) {
        params.dtfinal = dtfinal || null;
      }

      const response = await axios.get('/viagens/dashEstrategico', { params });
      setTotalizadores(response.data.totalizadores);
      setViagens(response.data.viagens);
    } catch (err) {
      const status = get(err, 'response.status', 0);
      const data = get(err, 'response.data', {});
      const errors = get(data, 'errors', []);

      if (errors.length > 0) {
        errors.map((error) => toast.error(error));
      } else {
        toast.error('Erro inesperado:', err);
      }

      if (status === 401) dispatch(actions.loginFailure());
    } finally {
      setIsLoading(false);
    }
  }

  function limparFiltros() {
    setIsLoading(true);

    setDtInicial(null);
    setDtFinal(null);
    setIdMotorista(null);
    setIdEmpresa(null);
    setIdCliente(null);
    setIdVeiculo(null);
    setViagens([]);
    setTotalizadores([]);

    setIsLoading(false);
  }

  const columns = useMemo(
    () => [
      {
        accessorKey: 'id',
        header: 'Nr.',
        size: 80,
      },
      {
        accessorKey: 'placa',
        accessorFn: (row) => row.placa || null,
        header: 'Placa',
        size: 80,
      },
      {
        accessorKey: 'retorno',
        accessorFn: (row) =>
          row.retorno ? moment(row.retorno).format('DD/MM/YYYY') : null,
        header: 'Data Retorno',
        size: 80,
      },
      {
        accessorKey: 'peso',
        accessorFn: (row) =>
          row.peso ? (
            <NumberFormatCustom value={row.peso} displayType="text" />
          ) : (
            ''
          ),
        header: 'Peso(T)',
        size: 80,
        muiTableBodyCellProps: { sx: { textAlign: 'right' } },
      },
      {
        accessorKey: 'nome_motorista',
        header: 'Nome Motorista',
        size: 80,
      },
    ],
    []
  );

  const cardsResumo = [
    {
      title: 'Receitas',
      unidade: 'R$',
      value: NumberFormat(totalizadores[0]?.total_receitas),
    },
    {
      title: 'Despesa',
      unidade: 'R$',
      value: NumberFormat(totalizadores[0]?.total_despesas),
    },
    {
      title: 'Resultado Líquido',
      unidade: 'R$',
      value: NumberFormat(totalizadores[0]?.lucro),
    },
    {
      title: 'Resultado Líquido',
      unidade: '%',
      value: NumberFormat(totalizadores[0]?.lucro_bruto),
    },
  ];

  const cardsGastos = [
    {
      title: 'Diesel',
      unidade: 'R$',
      value: NumberFormat(totalizadores[0]?.total_combustivel),
    },
    {
      title: 'Arla',
      unidade: 'R$',
      value: NumberFormat(totalizadores[0]?.total_arla),
    },
    {
      title: 'Descarga',
      unidade: 'R$',
      value: NumberFormat(totalizadores[0]?.total_descarga),
    },
    {
      title: 'Outras Despesas',
      unidade: 'R$',
      value: NumberFormat(
        (Number(totalizadores[0]?.total_outros) || 0) +
          (Number(totalizadores[0]?.total_adm) || 0) +
          (Number(totalizadores[0]?.total_veiculo) || 0)
      ),
    },
  ];

  const cardsMotorista = [
    {
      title: 'Comissão',
      unidade: 'R$',
      value: NumberFormat(totalizadores[0]?.total_comissao),
    },
    {
      title: 'Despesas Pagas',
      unidade: 'R$',
      value: NumberFormat(totalizadores[0]?.total_motorista),
    },
    {
      title: 'Adiantamento',
      unidade: 'R$',
      value: NumberFormat(totalizadores[0]?.total_adiantamentos),
    },
    {
      title: 'Saldo',
      unidade: 'R$',
      value: NumberFormat(totalizadores[0]?.saldo_motorista),
    },
    {
      title: 'Comissão / Km Rodado',
      unidade: 'R$',
      value: NumberFormat(totalizadores[0]?.comissao_km),
    },
  ];

  const cardsConsumo = [
    {
      title: 'Diesel',
      unidade: 'L',
      value: NumberFormat(totalizadores[0]?.quantidade_combustivel),
    },
    {
      title: 'Arla',
      unidade: 'L',
      value: NumberFormat(totalizadores[0]?.quantidade_arla),
    },
    {
      title: 'Arla',
      unidade: '%',
      value: NumberFormat(totalizadores[0]?.porcentual_arla),
    },
  ];

  const cardsGerenciais = [
    {
      title: 'KM Rodado',
      unidade: 'Km',
      value: NumberFormat(totalizadores[0]?.km_rodado),
    },
    {
      title: 'Consumo Médio',
      unidade: 'Km/L',
      value: NumberFormat(totalizadores[0]?.km_consumo),
    },
    {
      title: 'Custo Diesel',
      unidade: 'R$/L',
      value: NumberFormat(totalizadores[0]?.combustivel_valor_quantidade),
    },
    {
      title: 'Peso Transport.',
      unidade: 'T',
      value: NumberFormat(totalizadores[0]?.total_peso),
    },
    {
      title: 'Média Peso',
      unidade: 'KmL/T',
      value: NumberFormat(totalizadores[0]?.km_consumo_peso),
    },
    {
      title: 'Receita/Km',
      unidade: 'R$',
      value: NumberFormat(totalizadores[0]?.receita_km),
    },
    {
      title: 'Despesa/Km',
      unidade: 'R$',
      value: NumberFormat(totalizadores[0]?.despesa_km),
    },
    {
      title: 'Líquido/KM',
      unidade: 'R$',
      value: NumberFormat(totalizadores[0]?.lucro_km),
    },
    {
      title: 'ICMS',
      unidade: 'R$',
      value: NumberFormat(totalizadores[0]?.total_vlicms),
    },
    {
      title: 'PIS',
      unidade: 'R$',
      value: NumberFormat(totalizadores[0]?.total_vlpis),
    },
    {
      title: 'COFINS',
      unidade: 'R$',
      value: NumberFormat(totalizadores[0]?.total_vlcofins),
    },
    {
      title: 'Tributos/KM',
      unidade: 'R$',
      value: NumberFormat(totalizadores[0]?.tributos_km),
    },
  ];

  return (
    <ContainerPainel>
      <Loading isLoading={isLoading} />
      <Title>PAINÉIS</Title>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          '& .MuiTextField-root': { m: 0, width: { xs: '100%', sm: '100%' } },
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="pt-br"
            >
              <DatePicker
                required
                label="Data Inicial"
                size="small"
                value={dtinicial} // Assumindo que mes é um objeto de data
                onChange={(date) => setDtInicial(date)} // Armazena o objeto de data completo
                format="DD/MM/YYYY"
                inputFormat="DD/MM/YYYY"
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="pt-br"
            >
              <DatePicker
                required
                label="Data Final"
                size="small"
                value={dtfinal} // Assumindo que mes é um objeto de data
                onChange={(date) => setDtFinal(date)} // Armazena o objeto de data completo
                format="DD/MM/YYYY"
                inputFormat="DD/MM/YYYY"
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              id={id_motorista ? String(id_motorista) : ''}
              value={
                motoristas.find((option) => option.id === id_motorista) || null
              }
              options={motoristas}
              getOptionLabel={(option) => option.nome}
              onChange={(event, newValue) => {
                setIdMotorista(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...params}
                  label="Motorista"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              id={id_veiculo ? String(id_veiculo) : ''}
              value={
                veiculos.find((option) => option.id === id_veiculo) || null
              }
              options={veiculos}
              getOptionLabel={(option) => option.placa}
              onChange={(event, newValue) => {
                setIdVeiculo(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...params}
                  label="Veículo"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              id={id_empresa ? String(id_empresa) : ''}
              value={
                empresas.find((option) => option.id === id_empresa) || null
              }
              options={empresas}
              getOptionLabel={(option) => option.nome}
              onChange={(event, newValue) => {
                setIdEmpresa(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...params}
                  label="Empresa"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              id={id_cliente ? String(id_cliente) : ''}
              value={
                clientes.find((option) => option.id === id_cliente) || null
              }
              options={clientes}
              getOptionLabel={(option) => option.nome}
              onChange={(event, newValue) => {
                setIdCliente(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Cliente"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => fetchAll()}
              style={{ marginRight: '10px' }}
            >
              Filtrar
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => limparFiltros()}
            >
              Limpar Filtros
            </Button>
          </Grid>
        </Grid>
      </Box>
      <SubTitle
        style={{
          background: colors.cardColor4,
        }}
      >
        Resumo
      </SubTitle>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          '& .MuiTextField-root': { m: 0, width: { xs: '100%', sm: '100%' } },
        }}
      >
        <Grid container spacing={2}>
          {cardsResumo.map((card, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Grid item xs={12} sm={3} key={index}>
              <Card
                style={{
                  height: '90px',
                  marginBottom: '10px',
                  background: colors.cardColor4,
                  color: 'white',
                  borderRadius: '10px',
                  fontFamily: 'sans-serif',
                  TextDecoration: 'none',
                  fontSize: '1.2rem',
                }}
              >
                <CardContent>
                  <Typography gutterBottom>
                    {card.title} ({card.unidade})
                  </Typography>
                  <Divider
                    style={{
                      backgroundColor: 'white',
                      borderRadius: '10px',
                      fontSize: '1.2rem',
                    }}
                  />
                  <Typography>{card.value}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
      <SubTitle
        style={{
          background: colors.cardColor1,
        }}
      >
        Gastos
      </SubTitle>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          '& .MuiTextField-root': { m: 0, width: { xs: '100%', sm: '100%' } },
        }}
      >
        <Grid container spacing={2}>
          {cardsGastos.map((card, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Grid item xs={12} sm={3} key={index}>
              <Card
                style={{
                  height: '90px',
                  marginBottom: '10px',
                  background: colors.cardColor1,
                  color: 'white',
                  borderRadius: '10px',
                  fontFamily: 'sans-serif',
                  TextDecoration: 'none',
                  fontSize: '1.2rem',
                }}
              >
                <CardContent>
                  <Typography gutterBottom>
                    {card.title} ({card.unidade})
                  </Typography>
                  <Divider
                    style={{
                      backgroundColor: 'white',
                      borderRadius: '10px',
                      fontSize: '1.2rem',
                    }}
                  />
                  <Typography>{card.value}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
      <SubTitle
        style={{
          background: colors.cardColor5,
        }}
      >
        Motorista
      </SubTitle>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          '& .MuiTextField-root': { m: 0, width: { xs: '100%', sm: '100%' } },
        }}
      >
        <Grid container spacing={2}>
          {cardsMotorista.map((card, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Grid item xs={12} sm={3} key={index}>
              <Card
                style={{
                  height: '90px',
                  marginBottom: '10px',
                  background: colors.cardColor5,
                  color: 'white',
                  borderRadius: '10px',
                  fontFamily: 'sans-serif',
                  TextDecoration: 'none',
                  fontSize: '1.2rem',
                }}
              >
                <CardContent>
                  <Typography gutterBottom>
                    {card.title} ({card.unidade})
                  </Typography>
                  <Divider
                    style={{
                      backgroundColor: 'white',
                      borderRadius: '10px',
                      fontSize: '1.2rem',
                    }}
                  />
                  <Typography>{card.value}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
      <SubTitle
        style={{
          background: colors.cardColor2,
        }}
      >
        Consumo
      </SubTitle>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          '& .MuiTextField-root': { m: 0, width: { xs: '100%', sm: '100%' } },
        }}
      >
        <Grid container spacing={2}>
          {cardsConsumo.map((card, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Grid item xs={12} sm={4} key={index}>
              <Card
                style={{
                  height: '90px',
                  marginBottom: '10px',
                  background: colors.cardColor2,
                  color: 'white',
                  borderRadius: '10px',
                  fontFamily: 'sans-serif',
                  TextDecoration: 'none',
                  fontSize: '1.2rem',
                }}
              >
                <CardContent>
                  <Typography gutterBottom>
                    {card.title} ({card.unidade})
                  </Typography>
                  <Divider
                    style={{
                      backgroundColor: 'white',
                      borderRadius: '10px',
                      fontSize: '1.2rem',
                    }}
                  />
                  <Typography>{card.value}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
      <SubTitle
        style={{
          background: colors.cardColor3,
        }}
      >
        Indicadores Gerenciais
      </SubTitle>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          '& .MuiTextField-root': { m: 0, width: { xs: '100%', sm: '100%' } },
        }}
      >
        <Grid container spacing={2}>
          {cardsGerenciais.map((card, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Grid item xs={12} sm={3} key={index}>
              <Card
                style={{
                  height: '90px',
                  marginBottom: '10px',
                  background: colors.cardColor3,
                  color: 'white',
                  borderRadius: '10px',
                  fontFamily: 'sans-serif',
                  TextDecoration: 'none',
                  fontSize: '1.2rem',
                }}
              >
                <CardContent>
                  <Typography gutterBottom>
                    {card.title} ({card.unidade})
                  </Typography>
                  <Divider
                    style={{
                      backgroundColor: 'white',
                      borderRadius: '10px',
                      fontSize: '1.2rem',
                    }}
                  />
                  <Typography>{card.value}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Box>
        <SubTitle>VIAGENS</SubTitle>
        <ThemeProvider theme={createTheme(theme, ptBR)}>
          <MaterialReactTable
            columns={columns}
            data={viagens}
            enableRowActions
            enableColumnActions={false}
            enableColumnFilters={false}
            enablePagination
            enableSorting={false}
            enableBottomToolbar
            enableTopToolbar={false}
            initialState={{
              density: 'compact',
              showColumnFilters: false,
              showGlobalFilter: false,
            }}
            localization={MRT_Localization_PT_BR}
            renderRowActions={({ row }) => (
              <Box sx={{ display: 'flex', gap: '1rem' }}>
                <Tooltip arrow placement="left" title="Imprimir">
                  <div>
                    <Button onClick={() => handleOpen(row.getValue('id'))}>
                      <FaPrint size={16} />
                    </Button>
                  </div>
                </Tooltip>
                <Modal
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="modal-title"
                  aria-describedby="modal-description"
                >
                  <Box sx={style}>
                    {selectedId !== null && (
                      <RelatorioViagens
                        id={selectedId}
                        open={open}
                        onClose={handleClose}
                      />
                    )}
                  </Box>
                </Modal>
              </Box>
            )}
          />
        </ThemeProvider>
      </Box>
    </ContainerPainel>
  );
}
